"use client";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ServiceOrderDetails } from "@/types";

interface ServiceState {
  showOrderDetails: boolean;
  serviceOrderPayload: Partial<ServiceOrderDetails>;
}

const initialState: ServiceState = {
  showOrderDetails: false,
  serviceOrderPayload: {},
};

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    setShowOrderDetails: (state, action: PayloadAction<boolean>) => {
      state.showOrderDetails = action.payload;
    },
    setServiceOrderPayload: (
      state,
      action: PayloadAction<Partial<ServiceOrderDetails>>,
    ) => {
      state.serviceOrderPayload = action.payload;
    },
  },
});

export const { setShowOrderDetails, setServiceOrderPayload } =
  serviceSlice.actions;
export default serviceSlice.reducer;
